import React from 'react';
import { CodeBlock } from 'react-code-blocks'

const webhooksReference = () => {

    const notificationHeaderSample =
    `{
        notification: {
            type: "CARD_CREATED",
            hookDateTime: "2020-06-29T18:18:09.750Z",
            payload: {
                CardItem: {...}
            }
        }
    }`;

    const javascriptDecodeExample =
        `{
        ...
        // Include your crypto module
        const crypto = require('crypto');

        // Your Kanban Zone Webhook Key
        const secretKey = 'KeyGeneratedFromKanbanZone';

        // Create your hash of the payload using your key
        // createHmac method
        const myHash = crypto.createHmac('sha1', secretKey)
            .update(JSON.stringify(bodyJson.payload))
            .digest('hex')

        // Read the header from your request
        const kanbanZoneSignature = request.headers['X-KanbanZone-Signature'];    

        // Compare your output to the header received
        if (kanbanZoneSignature === myHash) {
            // :) We match - Thank you Kanban Zone for the information
        
        } else {
            // :( We do NOT match - You are not from Kanban Zone - good bye.
        }
        ...
    }`;
    const notificationResponseExample =
        `{
    "notification": {
        "type": "CARD_CREATED",
        "hookDateTime": "2020-09-17T21:24:33.255Z",
        "payload": {
            "CardItem": {
                ...
            }
        }
    }
}`;

    return (
        <div className="swagger-ui doc-page">
            <div className="information-container wrapper">
                <div className="info">
                    <h2 className="title">Webhooks</h2>
                    <h2>Overview</h2>
                    <p>
                        Webhooks are a notification indicating that an event has been triggered in your Kanban Zone Organization.
                        A webhook will push information to a destination endpoint you specify when an important event occurs.
                    </p>
                    <p>
                        Please refer to our <a className="link" rel="noopener noreferrer" target="_self" href="https://kanbanzone.com/knowledge-base/webhooks/">Knowledge Base</a> webhooks documentation for more information.
                    </p>
                    <p>
                        You can create webhooks for the following:
                    </p>

                    <strong>Card Events</strong>
                    <ul className="circle">
                        <li>Card Created - event is triggered when a new card is created on a board.</li>
                        <li>Card Moved - event is triggered when an existing card is moved on a board.</li>
                        <li>Card Updated - event is triggered when an existing card is updated on a board.</li>
                    </ul>
                    <br />

                    An <b>HTTPS POST</b> request will be sent to the destination url you configured. Each request will contain a notification type and a hook date time stamp.
                    The payload <b>CardItem</b> format can be found in our <b>Models</b> section (CardItemOutputModel) within our <a className="link" rel="noopener noreferrer" target="_self" href="./apiReference/">API Reference</a> documentation.

                    <p>
                        <CodeBlock
                            text={notificationHeaderSample}
                            showLineNumbers={false}
                            wrapLines
                        />
                    </p>

                    <h2>Security</h2>
                    <p>
                        For security reasons, you may want to validate and limit requests to those coming from Kanban Zone. If you choose to generate a key to use with webhooks from within Kanban Zone,
                        all requests sent from Kanban Zone will contain a hash signature in the header of the request as X-KanbanZone-Signature.
                        <br />
                        An <b>HMAC sha1</b> is used to compute the hash. Use the key you generated and your payload body to verify the request is coming from Kanban Zone.
                    </p>
                    <p>
                        You can create webhooks for the following:
                    </p>

                    <strong>Card Events</strong>
                    <ul className="a">
                        <li>Card Created - event is triggered when a new card is created on a board.</li>
                        <li>Card Moved - event is triggered when an existing card is moved on a board.</li>
                        <li>Card Updated - event is triggered when an existing card is updated on a board.</li>
                    </ul>
                    <br />

                    An <b>HTTPS POST</b> request will be sent to the destination url you configured. Each request will contain a notification type and a hook date time stamp.
                    <p>
                        <CodeBlock
                            text={javascriptDecodeExample}
                            showLineNumbers
                            wrapLines
                        />
                    </p>

                    <h2>Responses</h2>
                    <p>
                        All responses are wrapped as a notifcation with the CardItem within the payload node.
                        The notification.type and notification.hookDateTime will help you manage your received notifications.
                        The payload <b>CardItem</b> format can be found in our <b>Models</b> section within our <a className="link" rel="noopener noreferrer" target="_self" href="./apiReference/">API Reference</a> documentation.
                        <CodeBlock
                            text={notificationResponseExample}
                            showLineNumbers
                            wrapLines
                        />
                    </p>


                </div>
            </div>
        </div>
    );
}

export default webhooksReference;